import React, { useState, useCallback, useEffect } from "react";
import { WebChatContainer } from "@ibm-watson/assistant-web-chat-react";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  MsalProvider,
} from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import UnauthenticatedScreen from "../app/common/NotLoggedIn";
import { msalConfig } from "./authConfig";
import Encuesta from "../app/components/encuesta.html";

const API_BFF = process.env.NEXT_PUBLIC_API_BFF;

let reduser = "";
let conv_id = "";

const WebChatApp = ({ config = {} }) => {
  const [instance, setInstance] = useState(null);
  const [epaResponse, setEpaResponse] = useState(false);
  const [msalInstance] = useState(() => new PublicClientApplication(msalConfig));
  const [chatContainer, setChatContainer] = useState(null);

  const channel = config.channel || "";
  const aadUserId = config.aadUserId || "";

  useEffect(() => {
    if (aadUserId) {
      reduser = aadUserId;
    }
  }, [aadUserId]);

  const preRecieveHandler = useCallback((event, instance) => {
    if (event.data.output && event.data.output.generic) {
      event.data.output.generic.forEach((item) => {
        if (item.response_type === "option") {
          instance.updateAssistantInputFieldVisibility(false);
        } else {
          instance.updateAssistantInputFieldVisibility(true);
        }
      });
    }
  }, []);

  const preSendHandler = useCallback((event) => {
    conv_id = event.data.context.skills["main skill"].user_defined.conv_id;
    event.data.context.skills["main skill"].user_defined.reduser = reduser;
    event.data.context.skills["main skill"].user_defined.channel = channel;
    event.data.context.skills["main skill"].user_defined.access_commercial_ia = true;
  }, [channel]);

  const createOpenPanel = useCallback((instance) => {
    const customPanel = instance.customPanels.getPanel();
    const { hostElement } = customPanel;
    hostElement.style.backgroundColor = "white";
    hostElement.innerHTML = Encuesta;

    const okButton = hostElement.querySelector("#PreChatForm__OkButton");
    const ratingButtons = hostElement.querySelectorAll(".rating-btn");
    const commentsArea = hostElement.querySelector("#surveyComments");
    const spantext = hostElement.querySelector("#spanText");

    ratingButtons.forEach((btn) => {
      btn.addEventListener("mouseover", () => {
        btn.style.border = "2px solid blue";
        spantext.textContent = btn.id;
      });

      btn.addEventListener("mouseout", () => {
        btn.style.border = "1px solid #ddd";
        spantext.textContent = "";
      });

      btn.addEventListener("click", () => {
        ratingButtons.forEach((b) => (b.style.background = "white"));
        btn.style.background = "#e6f3ff";
        okButton.disabled = false;
        okButton.style.backgroundColor = "#007bff";
      });
    });

    okButton.addEventListener("click", async () => {
      if (okButton.disabled) {
        return;
      }

      const selectedRating = hostElement.querySelector(
        '.rating-btn[style*="background: rgb(230, 243, 255)"]'
      );
      const rating = selectedRating ? selectedRating.dataset.rating : null;
      const comments = commentsArea.value;

      if (rating) {
        okButton.textContent = "Procesando tu respuesta...";
        const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
        await sleep(3000);
        okButton.textContent = "Enviar";

        setEpaResponse(true);
        const sendEPAObject = {
          input: {
            message_type: "text",
            text: "EPA_RESPONSE",
          },
          context: {
            skills: {
              ["main skill"]: {
                user_defined: {
                  rating,
                  comments,
                },
              },
            },
          },
        };
        instance.send(sendEPAObject, { silent: true }).catch(console.error);
      }
      customPanel.close();
    });
  }, []);

  function handler(event, instance) {
    event.newViewState = {
      ...event.newViewState,
      mainWindow: true,
      launcher: false,
    };
    if (event.reason === "mainWindowMinimized") {
      event.cancelViewChange = true;
      if (epaResponse) {
        if (window.parent && config.onMinimize) {
          config.onMinimize();
        }
      } else {
        return new Promise((resolve) => {
          createOpenPanel(instance);
          const customPanel = instance.customPanels.getPanel();
          customPanel.open({ hidePanelHeader: false, disableAnimation: false });
          resolve();
        });
      }
    }
  }

  const handleLogout = () => {
    window.localStorage.removeItem("msalPayload");
    if (config.onMinimize) {
      config.onMinimize();
    }
    msalInstance.logoutPopup();
  };

  function messageChatbot(txt, instance, silent = false) {
    const maxChars = 2040;
    txt = txt.substring(0, maxChars);
    var send_obj = { input: { message_type: "text", text: txt } };

    instance.send(send_obj, { silent }).catch(function (error) {
      console.error("Sending message to chatbot failed:", error);
    });
  }

  function uploadFileFromAsst(selectedFile, instance) {
    if (!selectedFile) {
      console.error("No file selected.");
      return;
    }

    const reader = new FileReader();
    reader.readAsDataURL(selectedFile);
    reader.onloadend = () => {
      const base64String = reader.result
        .replace("data:", "")
        .replace(/^.+,/, "");

      fetch(`${API_BFF}/upload`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          customTag: "adjuntos",
          data: {
            uploaded_file_base64: base64String,
            fileName: selectedFile.name,
            contentType: selectedFile.type,
            conversation_id: conv_id,
          },
        }),
      })
        .then((response) => {
          if (response.ok) {
            return response.json();
          } else {
            throw new Error("File upload failed.");
          }
        })
        .then(async (data) => {
          var msg = data["msg"] ? data["msg"] : "";
          if (!msg) {
            messageChatbot(
              "Ha ocurrido un problema al cargar su archivo , inténtelo denuevo",
              instance
            );
            return;
          }
          messageChatbot(msg, instance);
        })
        .catch((error) => {
          console.error("Error while file uploading: ", error);
        });
    };
  }

  function fileUploadCustomResponseHandler(event, instance) {
    const { element } = event.data;

    element.innerHTML = `
        <div style="display: flex; flex-direction: column; align-items: flex-start; gap: 10px;">
            <input type="file" id="uploadInput" style="display: none;">
            <label for="uploadInput" 
                   id="uploadButton" 
                   class="WAC__button--primary WAC__button--primaryMd"
                   style="cursor: pointer; padding: 12px 18px; border-radius: 8px; 
                          background: #007bff; color: white; font-size: 16px; 
                          display: flex; align-items: center; gap: 8px; border: none;">
                Subir archivo
            </label>
            <span id="fileName" style="font-size: 14px; color: #555; text-align: left;"></span>
        </div>
    `;

    const uploadInput = element.querySelector("#uploadInput");
    const fileNameDisplay = element.querySelector("#fileName");
    const uploadButton = element.querySelector("#uploadButton");

    uploadInput.addEventListener("change", (event) => {
      const selectedFile = event.target.files[0];

      if (selectedFile) {
        if (selectedFile.type != "application/pdf") {
          alert("El archivo seleccionado no es un PDF, por favor seleccione un archivo PDF.");
          uploadInput.value = "";
          return;
        } else if (selectedFile.size > 10485760) {
          alert("El archivo seleccionado pesa más de 10mb, por favor seleccione un archivo de menos de 10mb");
          uploadInput.value = "";
          return;
        } else {
          fileNameDisplay.textContent = `📂 ${selectedFile.name}`;
          uploadFileFromAsst(selectedFile, instance);
          uploadButton.style.pointerEvents = "none";
          uploadButton.style.opacity = "0.5";
          uploadButton.style.cursor = "not-allowed";
        }
      } else {
        fileNameDisplay.textContent = "";
      }
    });
  }

  function onBeforeRender(instance, setInstance) {
    instance.updateCSSVariables({
      "BASE-font-family": "IBM Plex Sans, 'Helvetica Neue', Arial, sans-serif",
      "BASE-header-font-family": "IBM Plex Sans, Helvetica Neue, Arial, sans-serif",
      "LAUNCHER-color-background": "#000000",
      "BASE-header-background": "#000000",
      "BASE-bottom-position": "0px",
      "BASE-right-position": "0px",
      "BASE-top-position": "0px",
      "BASE-left-position": "0px",
      "BASE-line-height-med": "1.2em",
      "$ui-background": "#EBEFFB",
      "$chat-button": "#014194",
      "$chat-button-hover": "#014194",
      "$chat-button-text-hover": "#ffffff",
      "$chat-button-selected": "#014194",
      "cds--list-box__label": "#ffffffff",
      ".cds--list-box__field:hover .cds--list-box__label": "#ffffff",
      "$chat-button-text-selected": "#ffffff",
      "BASE-position": "absolute",
      "BASE-height": "100%",
      "BASE-width": "100%",
      "BASE-font-size-med": "16px",
    });

    instance.updateCustomMenuOptions([
      { text: "Cerrar sesión", handler: () => handleLogout() },
    ]);

    instance.updateLocale("es");
    instance.on({ type: "view:pre:change", handler: handler });
    instance.on({ type: "pre:send", handler: preSendHandler });
    instance.on({ type: "pre:receive", handler: preRecieveHandler });
    instance.on({
      type: "pre:restartConversation",
      handler: () => setEpaResponse(false),
    });

    instance.on({
      type: "customResponse",
      handler: (event, instance) => {
        if (
          event.data.message.user_defined &&
          event.data.message.user_defined.user_defined_type ===
            "user-file-upload"
        ) {
          fileUploadCustomResponseHandler(event, instance);
        }
      },
    });
  }

  useEffect(() => {
    const callbackId = msalInstance.addEventCallback((message) => {
      if (["msal:loginSuccess"].includes(message.eventType)) {
        const result = message.payload;
        reduser = result.account.username;
      } else if (["msal:handleRedirectEnd"].includes(message.eventType)) {
        const result = message.payload;
        if (!result) {
          window.localStorage.removeItem("msalPayload");
          msalInstance.logoutRedirect({
            onRedirectNavigate: (url) => {
              return false;
            },
          });
          return;
        }
      }
    });

    return () => {
      if (callbackId) {
        msalInstance.removeEventCallback(callbackId);
      }
    };
  }, [msalInstance]);

  return (
    <MsalProvider instance={msalInstance}>
      <AuthenticatedTemplate>
        <div style={{ width: '100%', height: '100%' }} ref={setChatContainer} />
        {chatContainer && (
          <WebChatContainer
            config={{
              element: chatContainer,
              openChatByDefault: true,
              shouldTakeFocusIfOpensAutomatically: true,
              hideCloseButton: false,
              hideCloseAndRestartButton: false,
              showRestartButton: true,
              showLauncher: false,
              integrationID: process.env.NEXT_PUBLIC_WA_INSTEGRATION_ID,
              region: "us-south",
              serviceInstanceID: "dab85146-7332-4b59-b664-66abbfc21b13",
              themeConfig: {
                corners: "square",
              },
              clientVersion: process.env.NEXT_PUBLIC_WA_CLIENT_VERSION,
            }}
            onBeforeRender={(instance) => onBeforeRender(instance, setInstance)}
          />
        )}
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        {channel === "teams" ? (
          <WebChatContainer
            config={{
              openChatByDefault: true,
              shouldTakeFocusIfOpensAutomatically: true,
              hideCloseButton: false,
              hideCloseAndRestartButton: false,
              showRestartButton: true,
              showLauncher: false,
              integrationID: process.env.NEXT_PUBLIC_WA_INSTEGRATION_ID,
              region: "us-south",
              serviceInstanceID: "dab85146-7332-4b59-b664-66abbfc21b13",
              themeConfig: {
                corners: "square",
              },
              layout: {
                showFrame: true,
                hasContentMaxWidth: false,
              },
              clientVersion: process.env.NEXT_PUBLIC_WA_CLIENT_VERSION,
            }}
            onBeforeRender={(instance) => onBeforeRender(instance, setInstance)}
          />
        ) : (
          <UnauthenticatedScreen text={""} msal={msalInstance} />
        )}
      </UnauthenticatedTemplate>
    </MsalProvider>
  );
};

export default WebChatApp;
